var chunkToChildrenMap = {
	"445": [
		96,
		409,
		957,
		763,
		206,
		834,
		622
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };